import { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $generateNodesFromDOM } from '@lexical/html';
import { $insertNodes, COMMAND_PRIORITY_HIGH, PASTE_COMMAND } from 'lexical';

function replaceH2WithH1(html: string): string {
  return html.replace(/<h2/g, '<h1').replace(/<\/h2>/g, '</h1>');
}

export const PasteHandlerPlugin = (): null => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return editor.registerCommand(
      PASTE_COMMAND,
      (event: ClipboardEvent) => {
        event.preventDefault();

        const clipboardData = event.clipboardData || (window as any).clipboardData;
        const html = clipboardData.getData('text/html');
        const replacedHtml = replaceH2WithH1(html);

        const parser = new DOMParser();
        const dom = parser.parseFromString(replacedHtml, 'text/html');

        const nodes = $generateNodesFromDOM(editor, dom);

        editor.update(() => {
          $insertNodes(nodes);
        });

        return true;
      },
      COMMAND_PRIORITY_HIGH,
    );
  }, [editor]);

  return null;
};
